export default "/app/global-wrapper-client/static/dde3903075ebf0fc6fcd6ce0b639d2da.woff";